import { Plot } from '../../core/plot';
import { Adaptor } from '../../core/adaptor';
import { binHistogram } from '../../utils/transform/histogram';
import { HistogramOptions } from './types';
import { adaptor } from './adaptor';
import { DEFAULT_OPTIONS } from './constant';

export type { HistogramOptions };

export class Histogram extends Plot<HistogramOptions> {
  /**
   * è·å é»è®¤éç½®é¡¹
   * ä¾å¤é¨ä½¿ç¨
   */
  static getDefaultOptions(): Partial<HistogramOptions> {
    return DEFAULT_OPTIONS;
  }

  /** å¾è¡¨ç±»å */
  public type: string = 'histogram';

  public changeData(data: HistogramOptions['data']) {
    this.updateOption({ data });

    const { binField, binNumber, binWidth, stackField } = this.options;
    this.chart.changeData(binHistogram(data, binField, binWidth, binNumber, stackField));
  }

  /**
   * è·åç´æ¹å¾çééå¨
   */
  protected getDefaultOptions() {
    return Histogram.getDefaultOptions();
  }

  /**
   * è·åç´æ¹å¾çééå¨
   */
  protected getSchemaAdaptor(): Adaptor<HistogramOptions> {
    return adaptor;
  }
}
